export const BankAccountModel = {
    IBAN: 'IBAN',
    CLABE: 'CLABE'
};
